//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`;
export const DropdownButton = styled.button`
    display: grid;
    place-items: center;
    border: 0;
    background-color: transparent;
    border-radius: 10px;
    transition: 0.4s;
    padding: 10px 8px;
    cursor: pointer;
    &.opened {
        transform: rotate(180deg);
    }
    &:hover {
        backdrop-filter: brightness(92%);
    }
`;